module.exports = __webpack_public_path__ + "img/partners_innovem.ef6b2cfc.png";